import React from "react";
import Slider from "react-slick";

import firstimage from "../../assets/img/creditimg.png";
import secimage from "../../assets/img/creditimgsec.png";
import thirimage from "../../assets/img/creditimgthi.png";
import forimage from "../../assets/img/creditimgfor.png";
import fivimage from "../../assets/img/creditfiv.png";
import siximage from "../../assets/img/creditsix-7.png";
import sevimage from "../../assets/img/creditimgsev.png";

const CarouselSection = () => {
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 3,
    speed: 500,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows:false,
    responsive: [
      {
        breakpoint: 1330,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          //   dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          //   dots: true,
        },
      },
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerMode:true
        },
      },
    ],
  };
  return (
    <div className="my-32">
      <div className="flex items-center justify-center">
        <h2
          className="text-3xl font-bold tracking-tight mx-8 sm:text-4xl sm:leading-none mb-7 mt-5"
          data-aos="fade-right"
          data-aos-duration="500"
        >
          <span
            className="text-yellow-400"
            data-aos="fade-right"
            data-aos-duration="200"
          >
            Instant Funding
          </span>{" "}
          Withdrawal
        </h2>
      </div>

      <Slider {...settings} className="xl:ml-16 sm:ml-8 mx-8">
        <div>
          <img src={firstimage} />
        </div>
        <div>
          <img src={secimage} />
        </div>
        <div>
          <img src={thirimage} />
        </div>
        <div>
          <img src={forimage} />
        </div>
        <div>
          <img src={fivimage} />
        </div>
        <div>
          <img src={siximage} />
        </div>
        <div>
          <img src={sevimage} />
        </div>
      </Slider>
    </div>
  );
};

export default CarouselSection;
